export const COHORT_BREAKDOWN_REASON = `breaking down by cohorts`;
export const MESSAGE_PREFIX_VIEW_FLOWS = `View as Flow is disabled when`;
export const TOP_PATHS_BREAKDOWN_REASON = `breaking down by top path`;
export const NUMERIC_PROPERTY_BREAKDOWN_REASON = `breaking down by a numeric property`;
export const DATE_PROPERTY_BREAKDOWN_REASON = `breaking down by a date property`;
